import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsComponentHtml {
    export const ID = 'html';

    export interface IData extends NICmsContentComponent.IData {
        text?: string;
    }
}
